module.exports = __webpack_public_path__ + "img/fd_ic_gzh.6811bc7f.svg";